import React from "react";
import clxs from "./cluster-banner.module.css";
import useClx from "../../../hooks/use-clx";
import Scroller from "../../Scroller";
import { useCarouselScroller } from "../../../hooks/use-carousel";
import Carousel from "../../Carousel";
import ClusterVillaBanner from "./ClusterVillaBanner";
import Item from "../../Carousel/Item";
import BreadCrumbs from "../../PropertyDetail/LohonoLayout/BreadCrumbs";
import ShareMenu from "../../PropertyDetail/LohonoLayout/ShareMenu";
import { Track } from "../../AnalyticsManager";
import usePathParam from "../../../hooks/use-path-params";
import FILLED_LEFT_ICON from "../../../assets/icons/filled-left-arrow.svg";

interface ClusterBannerProps {
  clusterVillas: ClusterPropertyImages[];
  carouselId: string;
  className?: string;
  containerClassName?: string;
  propertyName: string;
  address: string;
  onShare: () => Promise<boolean>;
  onViewPhotos: (selectedPropertyImages: ClusterPropertyImages) => void;
}

function ClusterBanner(props: ClusterBannerProps) {
  const {
      className,
      containerClassName,
      carouselId,
      propertyName,
      address,
      onShare,
      onViewPhotos,
      clusterVillas,
    } = props,
    ccx = useClx(clxs.container, className),
    cacx = useClx(clxs.carousel, containerClassName),
    location = usePathParam(PATH, "location"),
    destination = usePathParam(PATH, "destination"),
    locationUrl =
      "/villas/" +
      destination +
      "/" +
      location.trim().toLowerCase().replace(/\s+/g, ""),
    { scrollLeft, scrollRight } = useCarouselScroller(carouselId);
  return (
    <div className={ccx}>
      <Carousel
        id={carouselId}
        className={cacx}
        threshold={0.9}
        adjust={true}
        data-carausel={clusterVillas.length === 2}
      >
        {clusterVillas.map((oClusterVilla, key) => {
          return (
            <Item
              key={key}
              className={clxs.villaBannerItem}
              onClick={()=>onViewPhotos(oClusterVilla)}
            >
              <ClusterVillaBanner villa={oClusterVilla} />
            </Item>
          );
        })}
      </Carousel>
      <Scroller
        className={
          clusterVillas.length === 2 ? clxs.scrollHide : clxs.scroller
        }
        onScrollLeft={scrollLeft}
        onScrollRight={scrollRight}
        isSmallIcon={true}
      />
      <Track event="property_cluster_detail_share_clicked">
        <ShareMenu
          onShare={onShare}
          buttonClassName={clxs.shareButton}
          className={clxs.shareContainer}
        ></ShareMenu>
      </Track>
      <a
        className={clxs.backButton}
        href={locationUrl}
      >
        <img
          src={FILLED_LEFT_ICON}
          alt={""}
          className={clxs.backIcon}
        />
      </a>
      <div className={clxs.headerContainer}>
        <BreadCrumbs
          propertyName={propertyName}
          address={address}
          isCluster={true}
        ></BreadCrumbs>
        <ShareMenu 
          onShare={onShare}
          isCluster={true}
        ></ShareMenu>
      </div>
    </div>
  );
}

export default ClusterBanner;

const PATH = "/cluster-villas/:destination/:location/:property";